import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link } from "react-router-dom";

const Header = ({ children, hasHiddenAuthButtons }) => {
  let [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
     function checkLoginStatus() {
      const username = localStorage.getItem('username'); 
  
      if (username !== null && username !== "") {
        setLoggedIn(true);
      }
    }
  
    checkLoginStatus();
  }, []);

  let logOut = () => {

    localStorage.clear();
    // history.push("/login")
    window.location.reload()
  }


  return (
    <Box className="header">
      <Box className="header-title">
        <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>

      {children}

      {
        loggedIn ? (
          <Stack direction="row" spacing={2} style={{ justifyContent: 'center' }}>
          <div className="avatar" style={{ display: "flex", alignItems: "center",gap:"10px" }}>        
          <img src="avatar.png" alt={localStorage.getItem("username")}></img>
            <span>{localStorage.getItem("username")}</span>
          </div>      
            <Button variant="text" onClick={() => logOut()}>
              Logout
            </Button>
          </Stack>
        ):
      !hasHiddenAuthButtons ? (
        <div>
          <Link to="/login"><Button variant="text">Login</Button></Link>
          <Link to="/register"><Button variant="contained">Register</Button></Link>
        </div>
      ):(
        <Link to="/">
          <Button
            className="explore-button"
            startIcon={<ArrowBackIcon />}
            variant="text"
          >
            Back to explore
          </Button>
        </Link>
      )
    }
    </Box>
  );
};

export default Header;
